import { IRightDrawer } from './interfaces';

export const initState: IRightDrawer = {
  show: false,
  type: 'PROFILE',
};
